import { BasicPerson } from '../entities/Person/Person'

// @TODO: Remove one of the `getPersonFullName` functions
export const getPersonFullName = (person: BasicPerson): string => {
    const { firstname, affix, lastname } = person

    return `${firstname}${affix ? ` ${affix}` : ''} ${lastname}`
}
